module.exports = __webpack_public_path__ + "static/img/IMG_0897.7431abf.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0897.jpeg
// module id = JsaG
// module chunks = 0